module.exports = "pegasus_template/assets/theme6/google-icon.png";